import { useState } from 'react';
import { Question } from '../../types';

interface UseQuestionColumnsProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function useQuestionColumns({ question, onEdit }: UseQuestionColumnsProps) {
  const [newColumn, setNewColumn] = useState('');
  const [isAddingColumn, setIsAddingColumn] = useState(false);

  const addColumn = () => {
    if (newColumn.trim()) {
      const currentColumns = question.columns || [];
      onEdit(question.id, { columns: [...currentColumns, newColumn.trim()] });
      setNewColumn('');
      setIsAddingColumn(false);
    }
  };

  const cancelAddColumn = () => {
    setNewColumn('');
    setIsAddingColumn(false);
  };

  const removeColumn = (columnIndex: number) => {
    const currentColumns = question.columns || [];
    onEdit(question.id, {
      columns: currentColumns.filter((_, idx) => idx !== columnIndex),
    });
  };

  const updateColumn = (columnIndex: number, newValue: string) => {
    const currentColumns = question.columns || [];
    onEdit(question.id, {
      columns: currentColumns.map((col, idx) => (idx === columnIndex ? newValue : col)),
    });
  };

  const reorderColumns = (startIndex: number, endIndex: number) => {
    const currentColumns = Array.from(question.columns || []);
    const [movedColumn] = currentColumns.splice(startIndex, 1);
    if (movedColumn) {
      currentColumns.splice(endIndex, 0, movedColumn);
      onEdit(question.id, { columns: currentColumns });
    }
  };

  return {
    newColumn,
    isAddingColumn,
    setNewColumn,
    setIsAddingColumn,
    addColumn,
    cancelAddColumn,
    removeColumn,
    updateColumn,
    reorderColumns,
  };
}
